import React from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow';
import TableColumn from './TableColumn';
import TableBody from './TableBody';
import TableHead from './TableHead';
import TableHeadCol from './TableHeadCol';

class Table extends React.Component {
  static Row = TableRow;
  static Col = TableColumn;
  static Body = TableBody;
  static Head = TableHead;
  static TR = TableRow;
  static TD = TableColumn;
  static TH = TableHeadCol;

  render() {
    const { cols, head, children, zebra, className, hover } = this.props;
    let cls = 'table advanced';
    if (zebra) {
      cls += ' zebra';
    }
    if (hover) {
      cls += ' hover';
    }
    return (
      <div className={className ? `table-wrap ${className}` : 'table-wrap'}>
        <table className={cls}>
          {cols && (
            <colgroup>
              {cols.map((col, index) => {
                return <col key={index} width={col} />;
              })}
            </colgroup>
          )}
          {head && (
            <thead className="no-border">
              <tr>
                {head.map((item, index) => {
                  let it = item;
                  if (Array.isArray(it)) {
                    it = it.map((i, ii) => <div key={ii}>{i}</div>);
                  }
                  return <th key={index}>{it}</th>;
                })}
              </tr>
            </thead>
          )}
          {head && <tbody className="only-bottom-border">{children}</tbody>}
          {!head && children}
        </table>
      </div>
    );
  }
}

Table.propTypes = {
  cols: PropTypes.array,
  head: PropTypes.array,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};

export default Table;
